import { ListAlt } from '@material-ui/icons';
import React from 'react';

const QuizIcon = ({ color }) => <ListAlt style={{ color }} />;

export default QuizIcon;
